import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  Input,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { PersistenceService } from '../../shared/misc-services/persistence.service';
import { isSavingWithMinimumDuration$ } from '../../shared/navbar/saving-indicator/saving-indicator-helpers';
import { DraftSubmissionService } from '../submissions/draft-submission.service';
import { SubmitTaskButtonService } from '../submit-task-button/submit-task-button.service';

@Component({
  selector: 'h3-production-workspace-navbar',
  templateUrl: './production-workspace-navbar.component.html',
  styleUrls: ['./production-workspace-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductionWorkspaceNavbarComponent extends DirectiveSuperclass {
  @Input({ required: true }) stepId!: number;
  @Input() templateId?: string;

  private readonly store = inject(TaskWorkspaceStore);
  private readonly persistenceService = inject(PersistenceService);
  private readonly submitTaskButtonService = inject(SubmitTaskButtonService);

  isSaving$: Observable<boolean>;
  navbarSubmitEnabled =
    this.submitTaskButtonService.isNavbarSubmitButtonEnabled();
  isUsingObjects = this.store.isUsingObjects();

  constructor(
    draftSubmissionService: DraftSubmissionService,
    injector: Injector,
  ) {
    super(injector);
    this.isSaving$ = isSavingWithMinimumDuration$(
      this.isUsingObjects
        ? this.getIsSaving$()
        : draftSubmissionService.isSaving$,
      2000,
    );
  }

  private getIsSaving$() {
    return combineLatest([
      this.persistenceService.isSaving$(),
      this.persistenceService.getRetryCount$(),
    ]).pipe(
      map(([isSaving, retryCount]) => isSaving && retryCount === 0),
      distinctUntilChanged(),
    );
  }
}
